
  (function () {
    if (window.__centecProductCardGalleryReady) return;
    window.__centecProductCardGalleryReady = true;

    function getGalleryData(wrapper) {
      if (!wrapper) return [];
      if (wrapper.__centecGalleryData) return wrapper.__centecGalleryData;

      var dataNode = wrapper.querySelector('.centec-card-gallery__data');
      if (!dataNode) return [];

      try {
        wrapper.__centecGalleryData = JSON.parse(dataNode.textContent || '[]');
      } catch (error) {
        wrapper.__centecGalleryData = [];
      }

      return wrapper.__centecGalleryData;
    }

    function preloadImage(src) {
      if (!src) return;
      var preload = new Image();
      preload.src = src;
    }

    function updateGalleryPosition(wrapper, currentIndex, total) {
      if (!wrapper || total < 2) return;

      var position = wrapper.querySelector('[data-centec-gallery-position]');
      if (!position) return;

      var maxDots = 6;
      var visibleDots = Math.min(total, maxDots);
      var activeDot = Math.min(currentIndex, maxDots - 1);

      position.innerHTML = '';
      position.classList.remove('is-many', 'is-very-many');

      for (var i = 0; i < visibleDots; i++) {
        var dot = document.createElement('span');
        dot.className = 'centec-card-gallery__dot' + (i === activeDot ? ' is-active' : '');
        position.appendChild(dot);
      }
    }

    function initializeGalleryPositions(root) {
      var scope = root && root.querySelectorAll ? root : document;

      scope.querySelectorAll('[data-centec-card-gallery]').forEach(function (wrapper) {
        var gallery = getGalleryData(wrapper);
        if (gallery.length < 2) return;

        var currentIndex = parseInt(wrapper.dataset.centecGalleryIndex || '0', 10);
        updateGalleryPosition(wrapper, currentIndex, gallery.length);
      });
    }

    function showGalleryImage(wrapper, requestedIndex) {
      var gallery = getGalleryData(wrapper);
      var image = wrapper ? wrapper.querySelector('.centec-card-gallery__image') : null;

      if (!image || gallery.length < 2) return;

      var total = gallery.length;
      var index = ((requestedIndex % total) + total) % total;
      var item = gallery[index];

      if (!item || !item.src) return;

      wrapper.dataset.centecGalleryIndex = String(index);
      updateGalleryPosition(wrapper, index, total);
      image.classList.add('is-changing');

      var loader = new Image();

      loader.onload = function () {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = item.src;
        image.alt = item.alt || '';
        image.dataset.mediaId = String(item.id || '');

        requestAnimationFrame(function () {
          image.classList.remove('is-changing');
        });

        var nextItem = gallery[(index + 1) % total];
        if (nextItem) preloadImage(nextItem.src);
      };

      loader.onerror = function () {
        image.classList.remove('is-changing');
      };

      loader.src = item.src;
    }

    function bindGalleryButtons(root) {
      var scope = root && root.querySelectorAll ? root : document;

      scope.querySelectorAll('[data-centec-gallery-prev], [data-centec-gallery-next]').forEach(function (button) {
        if (button.dataset.centecGalleryBound === 'true') return;
        button.dataset.centecGalleryBound = 'true';

        /* Evita que el clic llegue al enlace del producto o al botón Añadir que vive en la misma zona */
        ['pointerdown', 'mousedown', 'touchstart'].forEach(function (eventName) {
          button.addEventListener(eventName, function (event) {
            event.stopPropagation();
          }, { capture: true, passive: true });
        });

        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          var wrapper = button.closest('[data-centec-card-gallery]');
          var gallery = getGalleryData(wrapper);
          if (!wrapper || gallery.length < 2) return false;

          var currentIndex = parseInt(wrapper.dataset.centecGalleryIndex || '0', 10);
          var direction = button.hasAttribute('data-centec-gallery-next') ? 1 : -1;

          showGalleryImage(wrapper, currentIndex + direction);
          return false;
        }, true);
      });
    }


    function bindGallerySwipe(root) {
      var scope = root && root.querySelectorAll ? root : document;

      scope.querySelectorAll('[data-centec-card-gallery]').forEach(function (wrapper) {
        if (wrapper.dataset.centecSwipeBound === 'true') return;

        var gallery = getGalleryData(wrapper);
        var media = wrapper.querySelector('.centec-card-gallery__media');
        var link = wrapper.querySelector('.centec-card-gallery__link');

        if (!media || gallery.length < 2) return;

        wrapper.dataset.centecSwipeBound = 'true';

        var startX = 0;
        var startY = 0;
        var lastX = 0;
        var lastY = 0;
        var tracking = false;
        var horizontalGesture = false;

        media.addEventListener('touchstart', function (event) {
          if (!event.touches || event.touches.length !== 1) return;

          var touch = event.touches[0];
          startX = touch.clientX;
          startY = touch.clientY;
          lastX = startX;
          lastY = startY;
          tracking = true;
          horizontalGesture = false;
        }, { passive: true });

        media.addEventListener('touchmove', function (event) {
          if (!tracking || !event.touches || event.touches.length !== 1) return;

          var touch = event.touches[0];
          lastX = touch.clientX;
          lastY = touch.clientY;

          var deltaX = lastX - startX;
          var deltaY = lastY - startY;

          if (Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15) {
            horizontalGesture = true;

            /* El gesto horizontal pertenece a la mini galería.
               El scroll vertical de la página sigue funcionando normalmente. */
            if (event.cancelable) {
              event.preventDefault();
            }
          }
        }, { passive: false });

        media.addEventListener('touchend', function (event) {
          if (!tracking) return;

          tracking = false;

          var deltaX = lastX - startX;
          var deltaY = lastY - startY;
          var isSwipe = horizontalGesture
            && Math.abs(deltaX) >= 36
            && Math.abs(deltaX) > Math.abs(deltaY) * 1.15;

          if (!isSwipe) {
            horizontalGesture = false;
            return;
          }

          var currentIndex = parseInt(wrapper.dataset.centecGalleryIndex || '0', 10);
          var direction = deltaX < 0 ? 1 : -1;

          /* Izquierda = foto siguiente / derecha = foto anterior */
          showGalleryImage(wrapper, currentIndex + direction);

          /* Bloquea el click del enlace que suele producirse justo después del swipe. */
          wrapper.__centecLastSwipeAt = Date.now();

          if (event.cancelable) {
            event.preventDefault();
          }

          event.stopPropagation();
          horizontalGesture = false;
        }, { passive: false });

        media.addEventListener('touchcancel', function () {
          tracking = false;
          horizontalGesture = false;
        }, { passive: true });

        if (link) {
          link.addEventListener('click', function (event) {
            var lastSwipeAt = wrapper.__centecLastSwipeAt || 0;

            if (Date.now() - lastSwipeAt < 450) {
              event.preventDefault();
              event.stopPropagation();
              event.stopImmediatePropagation();
            }
          }, true);
        }
      });
    }

    document.addEventListener('change', function (event) {
      if (!(event.target instanceof Element)) return;

      var swatch = event.target.closest('.color-swatch__radio[data-variant-featured-media]');
      if (!swatch) return;

      var card = swatch.closest('product-item');
      var wrapper = card ? card.querySelector('[data-centec-card-gallery]') : null;
      var gallery = getGalleryData(wrapper);
      var mediaId = String(swatch.dataset.variantFeaturedMedia || '');

      if (!wrapper || !mediaId || gallery.length < 2) return;

      var index = gallery.findIndex(function (item) {
        return String(item.id) === mediaId;
      });

      if (index >= 0) {
        showGalleryImage(wrapper, index);
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeGalleryPositions(document);
        bindGalleryButtons(document);
        bindGallerySwipe(document);
      }, { once: true });
    } else {
      initializeGalleryPositions(document);
      bindGalleryButtons(document);
      bindGallerySwipe(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeGalleryPositions(event.target || document);
      bindGalleryButtons(event.target || document);
      bindGallerySwipe(event.target || document);
    });
  })();

;

(function () {
  /*
    CENTEC V16 - AÑADIR DESDE TARJETAS SIN SALTOS NI REDIRECCIONES
    --------------------------------------------------------------
    Objetivo:
    - Funciona en tarjetas normales y en "DE TU INTERÉS".
    - Agrega por AJAX.
    - El popup global "Producto agregado al carrito" queda abierto
      hasta que el cliente elija Seguir comprando / Ir al carrito / X.
    - No abre el mini-cart.
    - No recarga /cart.
    - No sube al inicio de la página.
    - Evita que Focal capture el formulario silencioso.
  */

  if (window.__centecSilentCardAddReadyV16) return;

  window.__centecSilentCardAddReadyV16 = true;

  /*
    Marcamos también la bandera antigua para impedir que una copia
    previa del handler V15 pueda enlazarse después.
  */
  window.__centecSilentCardAddReady = true;

  var root =
    window.Shopify &&
    Shopify.routes &&
    Shopify.routes.root
      ? Shopify.routes.root
      : '/';

  var addUrl =
    root + 'cart/add.js';

  var cartUrl =
    root + 'cart.js';

  var miniCartSectionUrl =
    root + '?section_id=mini-cart';


  /* =========================================================
     UTILIDADES DE SCROLL
     ========================================================= */

  function captureScrollPosition() {
    return {
      x:
        window.pageXOffset ||
        document.documentElement.scrollLeft ||
        0,

      y:
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        0
    };
  }


  function restoreScrollPosition(position) {
    if (!position) return;

    try {
      window.scrollTo(
        position.x,
        position.y
      );
    } catch (error) {}
  }


  function protectScrollPosition(position) {
    restoreScrollPosition(position);

    window.requestAnimationFrame(
      function () {
        restoreScrollPosition(position);
      }
    );

    window.setTimeout(
      function () {
        restoreScrollPosition(position);
      },
      90
    );

    window.setTimeout(
      function () {
        restoreScrollPosition(position);
      },
      240
    );
  }


  /* =========================================================
     ACTUALIZAR CONTADORES
     ========================================================= */

  function paintCartCounts(count) {
    count =
      Number(count);

    if (
      !Number.isFinite(count) ||
      count < 0
    ) {
      return;
    }

    document.querySelectorAll(
      '[data-centec-cart-count], cart-count:not([data-centec-cart-count])'
    ).forEach(
      function (badge) {
        badge.textContent =
          count > 99
            ? '99+'
            : String(count);

        if (
          badge.hasAttribute(
            'data-centec-cart-count'
          )
        ) {
          badge.style.display =
            count > 0
              ? 'flex'
              : 'none';
        }
      }
    );
  }


  function refreshCartCount() {
    return fetch(
      cartUrl,
      {
        method: 'GET',
        credentials: 'same-origin',

        headers: {
          'Accept':
            'application/json'
        },

        cache: 'no-store'
      }
    )
      .then(
        function (response) {
          if (!response.ok) {
            throw new Error(
              'No se pudo leer el carrito'
            );
          }

          return response.json();
        }
      )
      .then(
        function (cart) {
          paintCartCounts(
            cart.item_count
          );

          return cart;
        }
      )
      .catch(
        function () {
          return null;
        }
      );
  }


  /* =========================================================
     ACTUALIZAR MINI-CART SIN ABRIRLO
     ========================================================= */

  function refreshMiniCartSilently() {
    var currentMiniCart =
      document.getElementById(
        'mini-cart'
      );

    if (
      !currentMiniCart ||
      currentMiniCart.hasAttribute(
        'open'
      )
    ) {
      return Promise.resolve();
    }

    return fetch(
      miniCartSectionUrl,
      {
        method: 'GET',
        credentials: 'same-origin',

        headers: {
          'X-Requested-With':
            'XMLHttpRequest'
        },

        cache: 'no-store'
      }
    )
      .then(
        function (response) {
          if (!response.ok) {
            throw new Error(
              'No se pudo refrescar mini-cart'
            );
          }

          return response.text();
        }
      )
      .then(
        function (html) {
          var parser =
            new DOMParser();

          var doc =
            parser.parseFromString(
              html,
              'text/html'
            );

          var freshMiniCart =
            doc.getElementById(
              'mini-cart'
            );

          if (!freshMiniCart) return;

          var liveMiniCart =
            document.getElementById(
              'mini-cart'
            );

          if (
            !liveMiniCart ||
            liveMiniCart.hasAttribute(
              'open'
            )
          ) {
            return;
          }

          liveMiniCart.innerHTML =
            freshMiniCart.innerHTML;
        }
      )
      .catch(
        function () {
          /* No interrumpimos la compra. */
        }
      );
  }


  /* =========================================================
     ESTADO VISUAL DEL BOTÓN
     ========================================================= */

  function setButtonFeedback(
    button,
    state
  ) {
    if (!button) return;

    if (
      !button.dataset
        .centecOriginalText
    ) {
      button.dataset.centecOriginalText =
        (
          button.textContent ||
          '+ Añadir'
        ).trim();
    }


    if (state === 'loading') {
      button.disabled = true;

      button.setAttribute(
        'aria-busy',
        'true'
      );

      button.textContent =
        'Añadiendo...';

      return;
    }


    if (state === 'success') {
      button.disabled = true;

      button.removeAttribute(
        'aria-busy'
      );

      button.textContent =
        'Agregado';

      window.setTimeout(
        function () {
          button.disabled = false;

          button.textContent =
            button.dataset
              .centecOriginalText ||
            '+ Añadir';
        },
        850
      );

      return;
    }


    button.disabled = false;

    button.removeAttribute(
      'aria-busy'
    );

    button.textContent =
      'Intenta nuevamente';

    window.setTimeout(
      function () {
        button.textContent =
          button.dataset
            .centecOriginalText ||
          '+ Añadir';
      },
      1300
    );
  }


  /* =========================================================
     AÑADIR PRODUCTO POR AJAX
     ========================================================= */

  function centecSilentAdd(
    form,
    button
  ) {
    if (!form) return;

    if (
      form.dataset.centecAdding ===
      'true'
    ) {
      return;
    }

    var scrollPosition =
      captureScrollPosition();

    var formData =
      new FormData(form);

    form.dataset.centecAdding =
      'true';

    setButtonFeedback(
      button,
      'loading'
    );

    protectScrollPosition(
      scrollPosition
    );

    fetch(
      addUrl,
      {
        method: 'POST',
        credentials: 'same-origin',

        headers: {
          'Accept':
            'application/json',

          'X-Requested-With':
            'XMLHttpRequest'
        },

        body:
          formData
      }
    )
      .then(
        function (response) {
          if (!response.ok) {
            return response
              .json()
              .catch(
                function () {
                  return {};
                }
              )
              .then(
                function (error) {
                  throw error;
                }
              );
          }

          return response.json();
        }
      )
      .then(
        function () {
          setButtonFeedback(
            button,
            'success'
          );

          /*
            El Header Centec detecta el POST /cart/add.js y abre
            el popup global de confirmación.

            Aquí NO:
            - navegamos a /cart;
            - hacemos reload;
            - abrimos drawer;
            - hacemos scroll al inicio.
          */
          protectScrollPosition(
            scrollPosition
          );

          return Promise.all([
            refreshCartCount(),
            refreshMiniCartSilently()
          ]);
        }
      )
      .catch(
        function () {
          setButtonFeedback(
            button,
            'error'
          );

          protectScrollPosition(
            scrollPosition
          );
        }
      )
      .finally(
        function () {
          form.dataset.centecAdding =
            'false';
        }
      );
  }


  /* =========================================================
     INTERCEPTAR CLICK ANTES QUE FOCAL
     ========================================================= */

  window.addEventListener(
    'click',
    function (event) {
      if (
        !(
          event.target instanceof
          Element
        )
      ) {
        return;
      }

      var button =
        event.target.closest(
          'form[data-centec-silent-add="true"] button[type="submit"]'
        );

      if (!button) return;

      var form =
        button.closest(
          'form[data-centec-silent-add="true"]'
        );

      if (!form) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      centecSilentAdd(
        form,
        button
      );

      return false;
    },
    true
  );


  /* =========================================================
     RESPALDO PARA ENTER / TECLADO / SUBMIT PROGRAMÁTICO
     ========================================================= */

  window.addEventListener(
    'submit',
    function (event) {
      var form =
        event.target;

      if (
        !(
          form instanceof
          HTMLFormElement
        ) ||
        !form.matches(
          '[data-centec-silent-add="true"]'
        )
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var button =
        form.querySelector(
          '.centec-card-primary-cta'
        ) ||
        form.querySelector(
          '.centec-global-add-button'
        ) ||
        form.querySelector(
          'button[type="submit"]'
        );

      centecSilentAdd(
        form,
        button
      );

      return false;
    },
    true
  );

})();
